export function zoomToFeature(zoomToFeature) {
    let options = {
        duration: zoomToFeature.duration || 1000,
        easing: zoomToFeature.easing || "out-quint"
    };
    if (!zoomToFeature.zoom) {
        zoomToFeature.mapView.goTo({ target: zoomToFeature.geometry }, options);
    }
    else {
        zoomToFeature.mapView.goTo({ target: zoomToFeature.geometry, zoom: zoomToFeature.zoom }, options);
    }
}
export function centerAndZoomFeature(centerFeature) {
    let options = {
        duration: centerFeature.duration || 1000,
        speedFactor: centerFeature.speedFactor || 0.2,
        easing: centerFeature.easing || "out-quint" // easing function to slow down when reaching the target
    };
    centerFeature.mapView.goTo({ target: centerFeature.event.mapPoint, zoom: centerFeature.zoomlevel }, options);
}
